import { forwardRef } from "react";
import classNames from "classnames";
import { Radio } from "antd";
import type { GetRef, RadioGroupProps } from "antd/lib";
import styles from "./styles.module.scss";

type RadioGroupRefType = GetRef<typeof Radio.Group>;

export const RadioGroup = forwardRef<RadioGroupRefType, RadioGroupProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <Radio.Group ref={ref} className={classNames(styles.group, className)} {...props}>
        {children}
      </Radio.Group>
    );
  },
);
